import { PersonalInfo } from '../types';
import { api } from '../../../services/api/axios';

// Helper function to map API response to PersonalInfo
const mapApiResponseToPersonalInfo = (apiData: any): PersonalInfo => {
  // Handle both camelCase and snake_case responses
  return {
    firstName: apiData.first_name || apiData.firstName || '',
    lastName: apiData.last_name || apiData.lastName || '',
    phoneCode: apiData?.billing?.phone_code || apiData?.phone_code || apiData?.phoneCode || '+66',
    phoneNumber: apiData.billing?.phone || apiData?.phoneNumber || apiData?.phone || '',
    billing: apiData?.billing,
    email: apiData.email || ''
  };
};

// Helper function to map PersonalInfo to API format
const mapPersonalInfoToApiFormat = (data: Partial<PersonalInfo>): any => {
  return {
    first_name: data.firstName,
    last_name: data.lastName,
    phoneCode: data.phoneCode,
    phoneNumber : data.phoneNumber,
    billing: {
      phone: data.phoneNumber,
      phone_code: data.phoneCode,
    },
    email: data.email
  };
};



export const myAccountService = {
    getPersonalInfo: async (): Promise<PersonalInfo> => {
        const _email = localStorage.getItem('email') || sessionStorage.getItem('email');
        if(!_email) {
            throw new Error('User email not found in storage');
        }
        try {
            
            const response = await api.get('/account/me', { params: { email: _email }});
            console.log('Mapped personal info:', _email);

            return mapApiResponseToPersonalInfo(response.data);
        } catch (error: any) {
            console.error('Error fetching personal info:', error);
            throw new Error(error?.response?.data?.message || 'Failed to fetch personal information');
        }
    },

    updatePersonalInfo: async (data: Partial<PersonalInfo>): Promise<PersonalInfo> => {
        try {

            const apiData = mapPersonalInfoToApiFormat(data);
            console.log('API data for updating personal info:', apiData);
            const response = await api.put('/account/me', apiData);
            return mapApiResponseToPersonalInfo(response.data);
        } catch (error: any) {
            console.error('Error updating personal info:', error);
            throw new Error(error?.response?.data?.message || 'Failed to update personal information');
        }
    }
}
